import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";
import {SharedDataService} from "../../../services/shared-data.service";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {FS3ValidationResult} from "../../../objects/validationResult";
import {FS3Notification} from "../../../objects/notification";

@Component({
  selector: 'app-export-article',
  templateUrl: './export-article.component.html',
  styleUrls: ['./export-article.component.scss']
})
export class ExportArticleComponent implements OnInit {

  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  private formValidationMessages = {
    required: 'Value is required.',
  };
  public validationResult: FS3ValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public textInput: FormControl = new FormControl('', [Validators.required, this.formValidator()]);
  state: string = 'loading';
  errMsg: string = '';
  public listItem: ListItem;
  public articleData: object;

  constructor(
    private sharedDataService: SharedDataService,
  ) { }

  ngOnInit(): void {
    this.application.apiService.getArticleItem(this.payload['uuid'], AppComponent.user ? AppComponent.user.magic_key : '')
      .subscribe(
        data => this.handleItem(data),
        error => this.handleItemsError(error))
  }

  public titleIdx = 0;
  private handleItem(data) {
    this.listItem = data['articleItem'];
    this.articleData = JSON.parse(this.listItem.itemFullData['data'])
    this.componentForm.addControl('textInput', this.textInput);
    if(this.listItem.itemFullData['static_html_alias']) {
      this.state = 'show_export_details';
      this.textInput.setValue(this.listItem.itemFullData['static_html_alias'])
    } else {
      this.state = 'start_export';
    }
    // //titleItemIdx = search loop
    // for (let i = 0; i < this.articleData['article'].length; i++) {
    //   if(this.articleData['article']['type']=='title') {
    //     this.titleIdx = i;
    //     break;
    //   }
    // }
    console.log('handleItem',this.listItem)
  }

  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }

    if (!this.textInput.valid) {
      const errorKey = Object.keys(this.textInput.errors)[0]; // get error key from input errors
      this.validationResult = {
        isValid: false,
        message: this.textInput.errors[errorKey] // get error string by errorKey
      };
      return false;
    } else {
      this.validationResult = null; //hide validationResult leftovers
    }

    this.doArticleExport();
    this.state = 'loading';

    return false
  }

  private doArticleExport() {
    this.application.apiService
      .exportArticleItem(this.payload['uuid'],this.payload['folderUUID'],this.textInput.value)
      .subscribe(
        data => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Article has been exported!';
          this.sharedDataService.pushNotification(notification);
          this.payload['listItem']['itemFullData']['static_html_alias'] = this.textInput.value;
          this.success.emit()
        },
        error => {
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
          } else {
            //maybe close dialog
          }
        }
      )
  }

  private formValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const value = control.value.toString().replace(/ /g, '');
      if (!value) {
        return {required: this.formValidationMessages.required}
      }

      // if (isNaN(value*1) || parseFloat(value) != parseInt(value)) {
      //   return {onlyDigitsRequired: this.formValidationMessages.onlyDigitsRequired}
      // }
      //
      // if (Math.abs(control.value) > 9999) {
      //   return {maxValueForbidden: this.formValidationMessages.maxValueForbidden}
      // }

      return null;
    };
  }

  public linkClick(link) {
    window.open(link, '_blank')
  }

  private handleItemsError({ errMsg, exception: { status } }) {
    this.state = 'error';
    this.errMsg = errMsg;
    // if (errMsg) {
    //   this.sharedDataService.pushNotification({ text: errMsg, type: 'error' })
    // }
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

  // public handleSubmit(event: Event | void = null): void {
  //   if (event) {
  //     event.stopPropagation();
  //   }
  //
  //   //this.dialogRef.close({ isConfirmed: true })
  //   this.success.emit()
  // }

}
